import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: { label: string; path: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered
          ? "items-center text-center"
          : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
            <span className="w-4 h-px bg-primary-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading font-black text-2xl md:text-3xl text-foreground-950">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {action && !centered && (
        <Link
          to={action.path}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}